import { UpdateProfile } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
export const updateProfileDetails = {
  data: () => ({}),
  mounted() {},
  methods: {
    async updateProfileDetailsMethod(inputParams) {
      try {
        this.loading = true;
        let result = await API.graphql(
          graphqlOperation(UpdateProfile, {
            input: inputParams,
          })
        );
        this.loading = false;
        var ResultObject = JSON.parse(result.data.UpdateProfile);
        if (ResultObject.status == "Successfully") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: ResultObject.status_message,
          };
          return "SUCCESS";
        } else {
          return "ERROR";
        }
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.errors[0].message,
        };
        this.loading = false;
        return "ERROR";
      }
    },
  },
};
